import React, { useEffect, useRef, useState } from "react";

const EASE = "cubic-bezier(0.16, 1, 0.3, 1)";

function useReveal() {
    const ref = useRef(null);
    const [seen, setSeen] = useState(false);
    useEffect(() => {
        if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
            setSeen(true);
            return;
        }
        const el = ref.current;
        if (!el) return;
        const io = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setSeen(true);
                    io.disconnect();
                }
            },
            { rootMargin: "0px 0px -8% 0px" }
        );
        io.observe(el);
        return () => io.disconnect();
    }, []);
    return [ref, seen];
}

export function Lines({ lines, className = "", lineClassName = "", delay = 0 }) {
    const [ref, seen] = useReveal();
    return (
        <span ref={ref} className={className}>
            {lines.map((line, i) => (
                <span key={i} className="block overflow-hidden pb-[0.08em]">
                    <span
                        className={`block will-change-transform ${lineClassName}`}
                        style={{
                            transform: seen ? "translateY(0%)" : "translateY(115%)",
                            transitionProperty: "transform",
                            transitionDuration: "1.1s",
                            transitionDelay: `${delay + i * 0.13}s`,
                            transitionTimingFunction: EASE,
                        }}
                    >
                        {line}
                    </span>
                </span>
            ))}
        </span>
    );
}

export function ImgReveal({ src, alt, className = "", imgClassName = "", delay = 0 }) {
    const [ref, seen] = useReveal();
    return (
        <div
            ref={ref}
            className={`overflow-hidden ${className}`}
            style={{
                clipPath: seen ? "inset(0% 0 0 0)" : "inset(100% 0 0 0)",
                transitionProperty: "clip-path",
                transitionDuration: "1.15s",
                transitionDelay: `${delay}s`,
                transitionTimingFunction: EASE,
            }}
        >
            <img
                src={src}
                alt={alt}
                loading="lazy"
                className={`h-full w-full object-cover ${imgClassName}`}
                style={{
                    transform: seen ? "scale(1)" : "scale(1.08)",
                    transitionProperty: "transform",
                    transitionDuration: "1.3s",
                    transitionDelay: `${delay}s`,
                    transitionTimingFunction: EASE,
                }}
            />
        </div>
    );
}

export function FadeUp({ children, className = "", delay = 0, y = 32 }) {
    const [ref, seen] = useReveal();
    return (
        <div
            ref={ref}
            className={className}
            style={{
                opacity: seen ? 1 : 0,
                transform: seen ? "translateY(0)" : `translateY(${y}px)`,
                transitionProperty: "opacity, transform",
                transitionDuration: "0.9s",
                transitionDelay: `${delay}s`,
                transitionTimingFunction: EASE,
            }}
        >
            {children}
        </div>
    );
}
